import angular from 'angular';

import {Footer} from './footer.component';

import './footer.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.layout.footer', [])
  .component('footerComponent', Footer)
  .name;
